import React, { useRef, useState } from 'react';
import { SHXEditor } from '../SHXEDitor.js';
import { useTranslation } from 'react-i18next';

const replaceLastCharacters = (original: string, replacement: string) => {
  return original.slice(0, -replacement.length) + replacement;
};

interface IMaxLengthTextViewer {
  maxLength: number;
  setDidExceed?: (didExceed: boolean) => void;
  text: string;
}
export const MaxLengthTextViewer = ({ maxLength, setDidExceed, text: initialText }: IMaxLengthTextViewer) => {
  const [newString, setNewString] = useState(initialText);
  const [keyVal, setKeyVal] = useState(0);
  const hasTruncatedRef = useRef(false);
  const { t } = useTranslation();

  return (
    <SHXEditor
      key={`maxlength-${keyVal}`}
      initialMarkdown={newString}
      maxLength={maxLength}
      readOnly
      disableMaxHeight
      disableMaxWidth
      onChangeCallback={(newVal) => {
        if (!setDidExceed) return;

        if (hasTruncatedRef.current) return;

        const isShorter = newVal.trim().length < initialText.trim().length;
        if (!isShorter) return;

        hasTruncatedRef.current = true;
        setNewString(replaceLastCharacters(newVal, t('commonComponents.maxLengthTextBox.more')));
        setKeyVal((orig) => orig + 1);
        setDidExceed(true);
      }}
    />
  );
};
